import cloneDeep from 'lodash/cloneDeep';

class PurchaseSalesHistory {
  constructor({ProductName, Recommended, Purchased, LastPurchaseDate, Unit, Source}) {
    this.ProductName = ProductName;
    this.Recommended = Recommended;
    this.Purchased = Purchased;
    this.LastPurchaseDate = LastPurchaseDate;
    this.Unit = Unit;
    this.Source = Source;
  }

  clone() {
    return cloneDeep(this);
  }

  static fromApiFormat(api) {

    var elements = [];

    api.forEach(function(element) {
      elements.push(
				new PurchaseSalesHistory({
  ProductName: element.ProductName,
  Recommended: Math.round(10 * element.Recommended) / 10,
  Purchased: Math.round(10 * element.Purchased) / 10,
  LastPurchaseDate: element.LastPurchaseDate,
  Unit: element.Unit,
  Source: element.Source,
}));
    }, this);

    return elements;
  }
}

export default PurchaseSalesHistory;
